/**
 *Created by jmmartinez on 05/05/19
 * v.1.1 04/11/2019 Añadida opción: Último mes.
 * v.1.2 28/02/2020 Añadida propiedad titulo
 * v.1.3 26/05/2020 Cambio de Contenedor a flex
 * v.1.4 03/06/2020 Añadida propiedad periodo, para prefijar los valores desde y hasta.
 * v.1.5 26/06/2020 Cambiado componentWillReceiveProps para reflejar los cambios de la propiedad periodo
 * v.2.0 30/09/2020 Cambiado a framework2
 * v.2.1 26/10/2020 En el constructor, las fechas por defecto se calculan getTimestampFromNowSinHora() para poner hora a cero.
 * v.2.2 26/07/2021 Cambiado el selector css de selectorPeriodoBajado a selectorPeriodo



 * v.2.3 10/10/2022 Añadido el tipo 15 dias centrados.
 * v.2.4 01/02/2023 En OnChange, devolvemos como segundo parámetro el tipo seleccionado
 *                  Añadida propiedad periodoInicial y su gestión en el constructor.
 * v.2.5 14/04/2023 Añadido el tipo próximos 15 días.
 * v.2.6 27/06/2023 Añadida propiedad intervaloMaximoDias.
 * v.2.7 17/09/2024 En la llamada a <Combobox se ha eliminado el parametro Popover
 *                  Creada la propiedad className para sustituir la que se use por defecto.
 * v.2.8 26/09/2024 Corregido getPeriodoDeTipo para que cuando periodo es null lo devuelva sin operarlo
 *                  Modificado render para ocultar los selectores de fecha en el tipo 0.
 *                  Modificado onChangeTipo para cuando el periodo es null
 *
 * v.2.9 04/10/2024 Añadida propiedad mostrarSoloCombo y su uso en el render
 * v.2.10 02/07/2025 Añadido el tipo Último año
 * */

import React from 'react'
import PropTypes from 'prop-types';

import {FormGroup} from "@blueprintjs/core";
import DateTimeInput from "../../blueprint/DateTimeInput";
import ComboBox from "../../blueprint/ComboBox";
import {getTimestampFromNowSinHora} from "../utils/DateUtils"
import {
    getPeriodoMesActual,
    getPeriodoAgnoActual,
    getPeriodoMes,
    getPeriodoTrimestre,
    getPeriodoUltimaSemana,
    getPeriodoUltimoMes,
    getPeriodoAgnoEscolar,
    getPeriodoUltimosDias,
    getPeriodoDiaActual,
    getPeriodo15DiasCentrados,
    getPeriodoProximos15Dias,
    corregirPeriodoPorDuracionMaxima,
    getFormattedDateFromPeriodo, getPeriodoUltimoAgno,
} from "../utils/PeriodoUtils"
import {filtrarConNombreCampo} from "../utils/FilterUtils"
import "../../resources/css/selectorperiodo.css"

const tipos= [
    {valor: 0, nombre: 'Todos los días'},
    {valor: 1, nombre: 'Intervalo'},
    {valor: 2, nombre: 'Año actual'},
    {valor: 3, nombre: 'Mes actual'},
    {valor: 4, nombre: 'Trimestre 1º'},
    {valor: 5, nombre: 'Trimestre 2º'},
    {valor: 6, nombre: 'Trimestre 3º'},
    {valor: 7, nombre: 'Trimestre 4º'},
    {valor: 8, nombre: 'Enero'},
    {valor: 9, nombre: 'Febrero'},
    {valor: 10, nombre: 'Marzo'},
    {valor: 11, nombre: 'Abril'},
    {valor: 12, nombre: 'Mayo'},
    {valor: 13, nombre: 'Junio'},
    {valor: 14, nombre: 'Julio'},
    {valor: 15, nombre: 'Agosto'},
    {valor: 16, nombre: 'Septiembre'},
    {valor: 17, nombre: 'Octubre'},
    {valor: 18, nombre: 'Noviembre'},
    {valor: 19, nombre: 'Diciembre'},
    {valor: 20, nombre: 'Última semana'},
    {valor: 21, nombre: 'Último mes'},
    {valor: 22, nombre: 'Año escolar'},
    {valor: 23, nombre: 'Úĺtimos 10 días'},
    {valor: 24, nombre: 'Hoy'},
    {valor: 25, nombre: '15 dias centrados'},
    {valor: 26, nombre: 'Próximos 15 días'},
    {valor: 27, nombre: 'Último año'},
]

class SelectorPeriodo extends React.Component {

    constructor(props) {
        super(props)
        this.state = {
            valorDesde: props.periodo ? props.periodo.desde : getTimestampFromNowSinHora(), //new Date().getTime(),
            valorHasta: props.periodo ? props.periodo.hasta : getTimestampFromNowSinHora(), //new Date().getTime(),
            tipo: this.getTipoFromTipoValor(props.tipoValor),
        }
        this.inicializarTipos();
    }

    componentDidMount() {
        const {valorDesde, valorHasta} = this.state;
        const {tipoValor, periodo, onChange} = this.props;

        if (tipoValor) {
            let tipo=  this.getTipoFromTipoValor(tipoValor);
            let periodo = getPeriodoDeTipo(tipoValor);
            if (periodo) {
                //Llamamos a onChange para que se activen los mecanismos derivados de poner un periodo.
                //Por ejemplo, para que exista la condicion con este periodo por si le da al botón Buscar sin tocar nada.
                this.setState({tipo: tipo, valorDesde: periodo.desde, valorHasta: periodo.hasta}, () => {
                    onChange && onChange(periodo)
                });
            } else {
                this.setState({valorDesde: valorDesde, valorHasta: valorHasta});
            }
        }
        else{
            this.setState({valorDesde: valorDesde, valorHasta: valorHasta});
        }
    }


    //Para sustituir a WillṔrops
    static getDerivedStateFromProps(nextProps, prevState){
        const newState = {};

        //console.log("!!! SelectorPeriodo - getDerivedStateFromProps");

        if(nextProps.valorDesde && nextProps.valorDesde !== prevState.valorDesde){
            newState.valorDesde= nextProps.valorDesde;
        }

        if(nextProps.valorHasta && nextProps.valorHasta !== prevState.valorHasta){
            newState.valorHasta= nextProps.valorHasta;
        }

        if(nextProps.periodo && nextProps.periodo.desde && nextProps.periodo.desde !== prevState.valorDesde){
            //console.log("Periodo modificado: ");
            //console.log(nextProps.periodo.desde, " --> ", nextProps.periodo.desde);
            newState.valorDesde= nextProps.periodo.desde;
        }

        if(nextProps.periodo && nextProps.periodo.hasta && nextProps.periodo.hasta !== prevState.valorHasta){
            newState.valorHasta= nextProps.periodo.hasta;
        }


        if (Object.keys(newState).length > 0)
            return newState;
        else
            return null;
    }


    inicializarTipos= () => {
        const {tiposOcultos} = this.props;
        const setTiposOcultos = new Set();
        tiposOcultos.forEach((tipoOculto, index) => {
            setTiposOcultos.add(tipoOculto);
                });

        let tiposReales= [];
        tipos.forEach((tipo, index) => {
           if (!setTiposOcultos.has(tipo.valor))
               tiposReales.push(tipo);
        });

        this.tiposReales= tiposReales;
        console.log("tiposReales: ", tiposReales);
    }


    onChange= (origin, datetime) => {
        const {valorDesde, valorHasta, tipo} = this.state;
        const {intervaloMaximoDias, onChange} = this.props;


        //console.log("XXXX SelectorPeriodo - onChange");
        //console.log("origen: ", origin);
        //console.log("datetime: ", datetime);

        let periodo= {desde: valorDesde, hasta: valorHasta};
        if (origin === "valorDesde"){
            periodo.desde= datetime;
            this.setState({valorDesde: datetime});
        }
        if (origin === "valorHasta"){
            periodo.hasta= datetime;
            this.setState({valorHasta: datetime});
        }


        let periodoLimitado= corregirPeriodoPorDuracionMaxima(periodo, intervaloMaximoDias);
        console.log("periodoLimitado: ", getFormattedDateFromPeriodo(periodoLimitado));

        onChange && onChange(periodoLimitado, tipo);
    }

    getTipoFromTipoValor= (tipoValor) => {
        let elementos= filtrarConNombreCampo(tipos, "valor", tipoValor);
        if (elementos.length > 0)
            return elementos[0];
        else
            return null;
    }


    onChangeTipo= (tipo) => {
        const {onChange, intervaloMaximoDias} = this.props;
        let tipoValor= tipo.valor;
        let periodo= getPeriodoDeTipo(tipoValor);

        console.log("onChangeTipo------");
        console.log("periodo: ", periodo);
        if (periodo){
            let periodoLimitado= corregirPeriodoPorDuracionMaxima(periodo, intervaloMaximoDias);
            this.setState({tipo: tipo, valorDesde: periodoLimitado.desde, valorHasta: periodoLimitado.hasta}
                ,() => {
                    onChange && onChange(periodoLimitado)
                });
        }
        else{
            this.setState({tipo: tipo, valorDesde: null, valorHasta: null}
                ,() => {onChange && onChange()});
        }
    }

    render() {
        const {valorDesde, valorHasta, tipo} = this.state;
        const {className, titulo, width, mostrarSoloCombo} = this.props;
        let widthReal= width ? width : 500;
        let classNameReal = className ? className : "selectorPeriodo";
        let mostrarSelectoresDesdeHasta= tipo.valor > 0 && (!mostrarSoloCombo || !Boolean(mostrarSoloCombo) );
        let tituloReal= titulo && titulo != '' ? titulo : "Periodo";

        console.log("RENDER");
        console.log("valorDesde: ", valorDesde);
        console.log("valorHasta: ", valorHasta);

        return(
            <div className= {classNameReal}  style={{width: widthReal}}>
                {/*titulo &&  <div className="selectorPeriodoTitulo">{titulo}</div> */}
                <div className="selectorPeriodoContenedor">

                    {mostrarSelectoresDesdeHasta &&
                     <>
                        <div className="selectorPeriodoElemento">
                            <FormGroup label= "Desde">
                                <DateTimeInput valor={valorDesde} onChange={(datetime) => this.onChange("valorDesde", datetime)}/>
                            </FormGroup>
                        </div>
                        <div className="selectorPeriodoElemento">
                            <FormGroup label= "Hasta">
                                <DateTimeInput valor={valorHasta} onChange={(datetime) => this.onChange("valorHasta", datetime)}/>
                            </FormGroup>
                        </div>
                    </>
                    }

                    <div className="selectorPeriodoElementoLargo">
                        <FormGroup label= {tituloReal}>
                            <ComboBox
                                id="calendar"
                                icon="calendar"
                                fieldText="nombre"
                                fieldKey="valor"
                                items={this.tiposReales}
                                onValueChanged={(objeto) => this.onChangeTipo(objeto)}
                                placeholder= "Periodo"
                                filterable={false}
                                itemSelected= {tipo}
                                //label={titulo}
                                //labelInline={inline}
                            />

                        </FormGroup>
                    </div>
                </div>
            </div>
        );
    }

}


export const getPeriodoDeTipo= (tipoValor) => {
    console.log("GET PERIODO DE TIPO: ", tipoValor);

    var periodo= null;
    switch(tipoValor){
        case 0: break;
        case 1: break;
        case 2: periodo= getPeriodoAgnoActual(); break;
        case 3: periodo= getPeriodoMesActual(); break;
        case 4: case 5: case 6: case 7: periodo= getPeriodoTrimestre(tipoValor-3); break;
        case 8: case 9: case 10: case 11: case 12: case 13:
        case 14: case 15: case 16: case 17: case 18: case 19:
            periodo= getPeriodoMes(tipoValor-7); break;
        case 20: periodo= getPeriodoUltimaSemana(); break;
        case 21: periodo= getPeriodoUltimoMes(); break;
        case 22: periodo= getPeriodoAgnoEscolar(); break;
        case 23: periodo= getPeriodoUltimosDias(10); break;
        case 24: periodo= getPeriodoDiaActual(); break;
        case 25: periodo= getPeriodo15DiasCentrados(); break;
        case 26: periodo= getPeriodoProximos15Dias(); break;
        case 27: periodo= getPeriodoUltimoAgno(); break;
        default: break;
    }
    console.log("periodo: ", periodo);
    if (periodo != null) {
        periodo.desde = periodo.desde.getTime();
        periodo.hasta = periodo.hasta.getTime();
    }
    console.log("periodo: ", periodo);
    return periodo;
}



SelectorPeriodo.propTypes = {
    className: PropTypes.string,
    id: PropTypes.string,
    tipoValor: PropTypes.number,
    periodo: PropTypes.object,
    onChange: PropTypes.func,
    titulo: PropTypes.string,
    periodoInicial: PropTypes.object,
    intervaloMaximoDias: PropTypes.number,
    tiposOcultos: PropTypes.string,
    mostrarSoloCombo: PropTypes.bool,
}

export default SelectorPeriodo

